import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const CheckSquareIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      // strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        opacity="0.2"
        d="M2.75 2.75V12.25L3.75 13.25H13.25V2.75H2.75Z"
        fill="#2E2E2E"
      />
      <path
        d="M2.75 8.95455V3.25C2.75 3.11739 2.80268 2.99021 2.89645 2.89645C2.99021 2.80268 3.11739 2.75 3.25 2.75H12.75C12.8826 2.75 13.0098 2.80268 13.1036 2.89645C13.1973 2.99021 13.25 3.11739 13.25 3.25V12.75C13.25 12.8826 13.1973 13.0098 13.1036 13.1036C13.0098 13.1973 12.8826 13.25 12.75 13.25H8.47724"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 9.5L4 13.5L2 11.5"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CheckSquareIcon;
